<template>
  <div>
    <v-layout class="mt-2">
      <v-flex xs6>
        <BuscaSimplesApi
          id="identificadorsalaescola"
          style="width: 100%"
          label="Buscar"
          :disabled="acao != ''"
          route="gerencial/salaescola"
          :fieldSearch="buscarSelect"
          @found="encontrado"
          ref="buscaSimpleApi">
          <template slot-scope="propSlot">
            <span>{{ textoBuscaApi(propSlot.item) }}</span>
          </template>
        </BuscaSimplesApi>
      </v-flex>
      <v-flex xs4 class="ml-3">
        <Select :options="buscaOptions" v-model="buscarSelect" label="" @change="selectBuscaChange"/>
      </v-flex>
    </v-layout>

    <v-alert type="error" :value="($v.$invalid && $v.$dirty) || msgArrayError.length > 0" style="color: white;">
      <div v-if="$v.$invalid && $v.$dirty"> Preencha os campos corretamente.</div>
      <div v-if="msgArrayError.length > 0">
        <ul v-for="error of msgArrayError" :key="error.key">
          <li>{{ error }}</li>
        </ul>
      </div>
    </v-alert>

    <FormBasico
      :submit="onSubmit"
      :acao="acao"
      :novo="novaSalaEscola"
      :editar="editarSalaEscola"
      :excluir="excluirSalaEscola"
      :cancelar="cancelarSalaEscola"
      :id="form.identificadorsalaescola"
      class="mb-3">
      <!-- *******  -->
      <v-tabs>
        <v-tabs-slider color="#fff"></v-tabs-slider>
        <v-tab @click="tabelaSalaEscola">
          <v-icon left color="#757575">view_list</v-icon>
        </v-tab>
      </v-tabs>
    <!-- *******  -->

      <v-card class="pa-3">
            <!-- <Input type="text" label="Nome da Escola" disabled v-model="form.identificadorescola"/> -->
            <SelectBuscaApi
                  style="width: 60%;"
                  id="identificadorescola"
                  route="gerencial/escola"
                  fieldSearch="nomeescola"
                  label="Nome da Escola"
                  :disabled="acao == ''"
                  :v="$v.form.identificadorescola"
                  v-model="form.identificadorescola">
                  <template slot-scope="propSlot">
                    {{ propSlot.item.nomeescola }}
                  </template>
            </SelectBuscaApi>
            <Input type="text" label="Identificação da Sala" disabled v-model="form.identificadortiposala" />
            <Input type="text" ref="focusCampo" label="Descrição da Sala" :disabled="desabilitarCampos()" v-model="form.descricaosala" :v="$v.form.descricaosala" />
            <SelectBuscaApi
              style="width: 60%;"
              id="identificadortiposalaescola"
              route="gerencial/tiposala"
              fieldSearch="descricaotiposalaescola"
              label="Descrição do Modelo da Sala"
              :disabled="acao == ''"
              :v="$v.form.identificadortiposala"
              v-model="form.identificadortiposala">
              <template slot-scope="propSlot">
                {{ propSlot.item.descricaotiposalaescola }}
              </template>
            </SelectBuscaApi>
            <Input type="text" label="Quantos m² possui esta sala?" :disabled="desabilitarCampos()" v-model="form.areasala" :v="$v.form.areasala" @input="calculoVagas()"/>
            <Input type="text" label="Quantidade de vagas de acordo com o tamanho da sala" :disabled="desabilitarCampos()" v-model="form.quantidadevagasnormal" :v="$v.form.quantidadevagasnormal" />
            <!-- <Input type="text" label="Localização da sala dentro da escola" :disabled="desabilitarCampos()" v-model="form.indicalocalizacaosala" :v="$v.form.indicalocalizacaosala" /> -->
            <Validator label="Localização da sala dentro da escola" :v="$v.form.indicalocalizacaosala" >
              <Radio v-model="form.indicalocalizacaosala" :disabled="desabilitarCampos()" val="1" label="1º Piso"/>
              <Radio v-model="form.indicalocalizacaosala" :disabled="desabilitarCampos()" val="2" label="2º Piso"/>
              <Radio v-model="form.indicalocalizacaosala" :disabled="desabilitarCampos()" val="3" label="3º Piso"/>
              <Radio v-model="form.indicalocalizacaosala" :disabled="desabilitarCampos()" val="4" label="4º Piso"/>
            </Validator>
            <Input type="text" label="Descrição do Ambiente" :disabled="desabilitarCampos()" v-model="form.descricaoambiente" :v="$v.form.descricaoambiente" />

            <!-- <Input type="text" :disabled="desabilitarCampos()" label="Nº do INEP" v-model="form.numeroinep" :v="$v.form.numeroinep" />    -->
          </v-card>
    </FormBasico>
    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0"  >
        <div class="d-flex justify-space-between align-center">
           <span> {{ submitText }}</span>
            <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
        </div>
    </v-snackbar>
  </div>
</template>

<script>
import api from '@/api';
import BuscaSimplesApi from '@/components/BuscaSimplesApi';
import SelectBuscaApi from '@/components/SelectBuscaApi';
import {
  required, maxLength, minLength, alpha, integer, email, between,
} from 'vuelidate/lib/validators';
import { alphaSpace } from '@/validations';

const setFormInicial = () => ({
  identificadorsalaescola: '',
  identificadorescola: '',
  identificadortiposalaescola: '',
  descricaosala: '',
  areasala: '',
  descricaoambiente: '',
  quantidadevagasnormal: '',
  indicalocalizacaosala: '',
});

export default {
  name: 'escola',
  components: {
    BuscaSimplesApi,
    SelectBuscaApi,
  },
  data() {
    return {
      acao: '',
      form: setFormInicial(),
      msgError: '',
      msgArrayError: [],
      snackbar: false,
      submitText: '',
      formUltimo: {},
      buscarSelect: 'nomeescola',
      buscaOptions: [
        { value: 'identificadorsalaescola', text: 'Código da sala' },
        { value: 'descricaosala', text: 'Descrição da sala' },
      ],
    };
  },
  validations() {
    return {
      form: {

        identificadorescola: { required, integer },
        identificadortiposala: { required, maxLength: maxLength(5), integer }, // smallint
        descricaosala: { required, maxLength: maxLength(50), minLength: minLength(5) },
        descricaoambiente: { alphaSpace },
        quantidadevagasnormal: { maxLength: maxLength(5), integer }, // smallint
        indicalocalizacaosala: { maxLength: maxLength(1), integer },
      },
    };
  },
  watch: {
    form: {
      handler(val) {
        // if(val.indicaescolaanexa == 'N')
        //   this.form.descricaoescolasede = ''

        // if(val.tipodependenciaadministrativa != '4'){
        //   this.form.tipocategoriaescolaprivada = ''
        //   this.form.tipomantenedoraescolaprivada = ''
        //   this.form.cnpjmantenedoraprincipal = ''
        // }
        // else{
        //   this.form.tipoorgaoescolavinculada = ''
        // }

        // this.form.tipolocalizadiferenciadaescola = (val.tipozonalocalizacao == '1')? '7' : val.tipolocalizadiferenciadaescola

        // if(val.indicanacionalidadeescola != 'I'){
        //   this.form.nomecidadeinternacionalescola = ''
        //   this.form.nomepaisinternacionalescola = ''
        // }
        // else{
        //   this.form.codigologradouro = ''
        //   this.form.descricaocomplementoendereco = ''
        //   this.form.numeroimovel = ''
        // }
      },
      deep: true,
    },
  },
  methods: {
    //*************    */
  calculoVagas(){
      this.form.quantidadevagasnormal = Math.trunc(this.form.areasala/1);
  },
    tabelaSalaEscola(){
      this.$root.$router.push({
          name: 'tabelas',
          params: {
            titulo: 'Sala por Escola / Listar',
            rota_api: 'gerencial/salaescola/tabela',
            headers: [
                      { text: 'Identificador', value: 'identificadorsalaescola', filtable: true, sortable: false},
                      { text: 'Escola', value: 'nomeescola', sortable: false, filtable: true},
                      { text: 'Descrição', value: 'descricaosala', sortable: false, filtable: true},
                      { text: 'Tamanho da Sala(m²)', value: 'areasala', sortable: false, filtable: true},
                      { text: 'Localização da Sala', value: 'indicalocalizacaosala', sortable: false, filtable: false},
                      { text: 'Descrição do Modelo de Sala', value: 'descricaotiposalaescola', sortable: false, filtable: true}]
          }
      });
    },
//*************** */

    exibeZonaLocalizacao() {
      if (this.acao == '' && !this.form.codigologradouro) { return ''; }

      switch (this.form.tipozonalocalizacao) {
        case '1': return 'Urbana';
        case '2': return 'Rural';
        default: return '';
      }
    },
    novaSalaEscola() {
      this.acao = 'novo';
      this.form = setFormInicial();
      this.form = {
        ...this.form, // ,
        // nomesuperitendenciaensino: 'Superintendência Regional de Ensino de Coronel Fabriciano'
      };
      this.$v.$reset();
      setTimeout(() => this.$refs.focusCampo.$refs.input.focus(), 200);
    },
    editarSalaEscola() {
      if (this.form.identificadorsalaescola !== '') {
        this.acao = 'editar';
      }
    },
    async excluirSalaEscola() {
      const confirmar = await this.$sgal({
        title: 'Tem certeza?',
        text: 'Deseja realmente excluir esta sala?',
        type: 'warning',
        buttons: [
          { text: 'Excluir', color: 'red', response: true },
          { text: 'Cancelar', color: 'grey', response: false },
        ],
      });

      if (confirmar) {
        try {
          const { data } = await api.delete(`gerencial/salaescola/${this.form.identificadorsalaescola}`);

          this.acao = '';
          this.submitText = data.message;
          this.snackbar = true;
          this.form = setFormInicial();
          this.msgArrayError = [];
        } catch (error) {
          const ntfExcluir = await this.$sgal({
            title: 'Não foi possível!',
            text: error.response.data.errorMessage[0],
            type: 'notification',
          });
        }
      }
    },
    cancelarSalaEscola() {
      if (this.acao === 'novo') {
        this.form = setFormInicial();
      } else {
        this.form = { ...this.formUltimo };
      }
      console.log('teste');
      this.acao = '';
      this.msgArrayError = [];
      this.$v.$reset();
    },
    onSubmit() {
      this.$v.$touch();
      console.log(this.form);
      if (this.$v.$invalid) {
        if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
        return;
      }
      api({
        method: (this.acao === 'novo') ? 'post' : 'put',
        url: `gerencial/salaescola${(this.acao === 'novo') ? '' : `/${this.form.identificadorsalaescola}`}`,
        data: this.form,
      }).then((response) => {
        this.acao = '';
        this.submitText = response.data.message;
        this.snackbar = true;
        this.msgArrayError = [];

        if (this.acao == '') { this.form = { ...response.data.results }; }
      }).catch((error) => {
        if (error.response.data.status == 'ERROR_BUSINESS_RULE') { this.msgArrayError = error.response.data.errorMessage; }
        if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
      });
      this.$v.$reset();
    },
    encontrado(dados) {
      console.log(dados);
      this.form = setFormInicial();
      this.form = { ...dados };
      this.formUltimo = { ...this.form };
    },

    desabilitarCampos() {
      return (this.acao == 'editar') ? (this.acao == '' || this.form.tiposituacaofuncionamento == 3) : this.acao == '';
    },
    selectBuscaChange() {
      this.$refs.buscaSimpleApi.busca = '';
    },
    selectBuscaEscola() {
      this.$refs.Select.$options = api.get('gerencial/escola');
      // .then(response => {
      // this.acao = '';
      // this.submitText = response.data.message;
      //  this.snackbar = true;
      // this.form = setFormInicial()
      // this.$options =
      //  };
    },
    textoBuscaApi(dados) {
      let nomeCidade = '';
      const tipoDependenciaAdministrativa = '';

      // if(dados.tipodependenciaadministrativa)
      //   tipoDependenciaAdministrativa = `, ${ this.getTipoDependenciaAdministrativa(dados.tipodependenciaadministrativa) }`

      if (dados.escola.logradouro.nomecidade || dados.escola.nomecidadeinternacionalescola) { nomeCidade = ` - ${((dados.escola.logradouro) ? dados.escola.logradouro.nomecidade : dados.escola.nomecidadeinternacionalescola).toLowerCase().replace(/(^|\s)\S/g, l => l.toUpperCase())}`; }

      return `${dados.descricaosala}, ${dados.escola.nomeescola}${tipoDependenciaAdministrativa}${nomeCidade}`;
    },
  },
};
</script>

<style lang="scss">
.escola-card-dados{
  display: block;
  padding: 10px 16px;

  &> div {
    margin: 3px 0px;
  }

  .escola-card-dados-itens{
    display: flex;
    flex-wrap: wrap;
    div{
      margin-right: 7%;
      white-space: nowrap;
    }
  }
}
</style>
